import { render } from "./Before_Access_Checkout.vue?vue&type=template&id=e8c36fac&scoped=true"
import script from "./Before_Access_Checkout.vue?vue&type=script&lang=js"
export * from "./Before_Access_Checkout.vue?vue&type=script&lang=js"

import "./Before_Access_Checkout.vue?vue&type=style&index=0&id=e8c36fac&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c36fac"]])

export default __exports__